import React from 'react';
import OrganicTrafficSplineChart from '../OrganicTrafficSplineChart';
import OrganicTrafficBarChart from '../OrganicTrafficBarChart';
import ProductsWithOrganicTrafficSplineChart from '../ProductsWithOrganicTrafficSplineChart';
import KeywordsWithOrganicTrafficSplineChart from '../KeywordsWithOrganicTrafficSplineChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import OrganicTrafficGrid from '../OrganicTrafficGrid';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import { isTopicOrTopicGroupType } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils';
import { TopicOrTopicGroupPage } from './TopicOrTopicGroupPage';
import { NonTopicOrTopicGroupPage } from './NonTopicOrTopicGroupPage';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

export default function OrganicTrafficPage() {
  const mainEntityType = useMainEntityType();

  if (shouldShowBeaconProTopics() && isTopicOrTopicGroupType(mainEntityType)) {
    return <TopicOrTopicGroupPage />;
  }

  if (shouldShowBeaconProTopics() && !isTopicOrTopicGroupType(mainEntityType)) {
    return <NonTopicOrTopicGroupPage />;
  }

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_SPLINE.name}
          chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_SPLINE_CHART}
        >
          <OrganicTrafficSplineChart />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_ORGANIC_TRAFFIC_BAR.name}
          chartName={CHART_NAMES.BEACON_ORGANIC_TRAFFIC_BAR_CHART}
        >
          <OrganicTrafficBarChart />
        </ChartContextProvider>
        {mainEntityType !== 'product' && (
          <ChartContextProvider
            group={CHART_CONTEXT_GROUPS.BEACON_PRODUCTS_WITH_ORGANIC.name}
            chartName={CHART_NAMES.BEACON_PRODUCTS_WITH_ORGANIC_SPLINE}
          >
            <ProductsWithOrganicTrafficSplineChart />
          </ChartContextProvider>
        )}
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_KEYWORDS_WITH_ORGANIC.name}
          chartName={CHART_NAMES.BEACON_KEYWORDS_WITH_ORGANIC_SPLINE}
        >
          <KeywordsWithOrganicTrafficSplineChart />
        </ChartContextProvider>
        <OrganicTrafficGrid />
      </Flex>
    </BasePageContainer>
  );
}
